import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {forkJoin, Observable, throwError} from 'rxjs';
import {catchError, map, mergeMap, shareReplay} from 'rxjs/operators';

import {ICruisePrefetchParams} from '../interfaces/icruise-prefetch-params';
import {ICruisePrefetch} from '../interfaces/icruise-prefetch';

import {EnvironmentService} from './environment.service';
import {ProjectService} from './project.service';

import { Networks } from '../models/networks.enum';

import fixArray from '../../../utils/fixArray';

@Injectable({
  providedIn: 'root'
})
export class CruisePrefetchService {

  constructor(
    private _environmentService: EnvironmentService,
    private _projectService: ProjectService,
    private _http: HttpClient,
  ) { }

  httpCache = new Map<string, Observable<any>>();

  prefetch(params: ICruisePrefetchParams): Observable<ICruisePrefetch> {
    return forkJoin([
      this._environmentService.getEnvironment(),
      this._projectService.getAgencyApikey(),
      this._projectService.getAgencyNetwork(),
      this._projectService.hasOnlyNetQuotes()
    ]).pipe(
      mergeMap(e => {
        const hasOnlyNetQuotes = e[3];
        if (Number(e[2].id_network) && Number(e[2].id_network) === Networks.WTG) {
          params.onlyNetworkQuotes = hasOnlyNetQuotes;
        }
        const url = `${e[0].searchUrl}/index.php/cruise/${e[1]}/prefetch`;
        const key = url + JSON.stringify(params);
        if (!this.httpCache.get(key)) {
          this.httpCache.set(key, this._http.post<any>(url, params).pipe(shareReplay({bufferSize: 1, refCount: true})));
        }
        return this.httpCache.get(key);
      }),
      map(e => e.prefetch),
      map(e => {
        const prefetch: ICruisePrefetch = {
          days: fixArray(e.Days_Collection?.Day),
          departures: fixArray(e.Departures_Collection?.Departure),
          found: e.found,
          harbours: fixArray(e.Harbours_Collection?.Harbour),
          itineraries: fixArray(e.Itineraries_Collection?.Itinerary),
          ships: fixArray(e.Ships_Collection?.Ship),
          steps: fixArray(e.StepList_Collection?.Step),
          tops: fixArray(e.Tops_Collection?.Top),
        };
        return prefetch;
      }),
      shareReplay({bufferSize: 1, refCount: true}),
      catchError(err => throwError(err))
    );
  }
}
